<template>
    <div>
        <div class="text-muted d-flex">
            <span class="text-nowrap">
                <i class="far fa-clock"></i>
                <small> {{item.in_h}}:{{item.in_m}}&nbsp; </small>
            </span>
            <span class="text-nowrap ml-3">
                <span v-if="item.in_flg == '6'" class="text-success">
                    <i class="fas fa-handshake"></i>
                    <small> 入場済み </small>
                </span>
                <span v-else-if="item.in_flg =='y'" class="text-danger">
                    <i class="fas fa-calendar-times"></i>
                    <small> 取消済み </small>
                </span>
                <span v-else-if="item.is_agree == '0'" class="text-warning-cust">
                    <i class="far fa-check-circle"></i> 
                    <small> 承諾済み </small>
                </span>
                <span v-else-if="item.is_agree == '1'" class="text-danger">
                    <i class="fas fa-exclamation-circle"></i>
                    <small> 承諾待ち </small>
                </span>
            </span>
            <div class="text-nowrap let-space-1 mr-3 flex-fill text-right" @click="controlInfo">
                <small>{{btnText}}</small>
            </div>
            <div class="text-right">
                <span class="text-muted pl-2 ml-auto" @click="openMenu(item)">
                    <i class="fas fa-ellipsis-v"></i>
                </span>
            </div>
        </div>
        <div v-show="show">
            <div class="text-muted">
                <span class="text-nowrap">
                    <i class="fas fa-id-badge"></i>
                    <small> {{item.in_name}}さん&nbsp; </small>
                </span>
                <span class="text-nowrap">
                    <i class="fas fa-phone"></i>
                    <small> {{item.in_phone}}&nbsp; </small>
                </span>
            </div>
            <div class="text-muted">
                <span class="all-break-cust">
                    <i class="fas fa-map-marked-alt"></i>
                    <small> {{item.in_place}} </small>
                </span>
            </div>
            <div class="text-muted">
                <div>
                    <span>
                        <i class="fas fa-yen-sign"></i>
                        <small v-if="item.price_hope_start == item.price_hope_end"> {{ item.price_hope_end }}万円&nbsp; </small>
                        <small v-else>{{ item.price_hope_start }} ~ {{ item.price_hope_end }}万円&nbsp;&nbsp; </small>
                    </span>
                    <span v-if="item.price_pub == '0'" class="text-success">
                        <i class="fas fa-comments-dollar"></i>
                        <small v-if="item.price_pub_start == item.price_pub_end"> {{ item.price_pub_end }}万円&nbsp; </small>
                        <small v-else>{{ item.price_pub_start }} ~ {{ item.price_pub_end }}万円&nbsp; </small>
                    </span>
                </div>
            </div>
            <div class="text-muted">
                <span v-if="item.gender == '0'" class="text-nowrap">
                    <i class="fas fa-male"></i>
                    <small>男性&nbsp;</small>
                </span>
                <span v-else class="text-nowrap">
                    <i class="fas fa-female"></i>
                    <small>女性&nbsp;</small>
                </span>
                <span class="text-nowrap">
                    <i class="fas fa-user-graduate"></i>
                    <small> {{item.age}}歳&nbsp; </small>
                </span>
                <span class="text-nowrap">
                    <i class="fas fa-user-tie"></i>
                    <small> {{item.exper}}年経験&nbsp; </small>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from 'js/event-bus'

    export default {
        props: {
            item: Object
        },
        data () {
            return {
                // false:一部　true:All
                show: false
            }
        },
        computed: {
            btnText () {
                return this.show ? '一部を表示' : 'もっと見る'
            }
        },
        methods: {
            controlInfo () {
                this.show = !this.show
            },
            openMenu () {
                EventBus.$emit('enterDetailMenu', this.item)
            }
        }
    }
</script>

<style>

</style>
